module.exports = __webpack_public_path__ + "static/media/SingleShift.9f532833.svg";